import { render, staticRenderFns } from "./add-files.vue?vue&type=template&id=bc3a2944&lang=pug"
import script from "./add-files.vue?vue&type=script&lang=js"
export * from "./add-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports